import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {HistEtree} from '../models/hist-etree';
import {Etree} from '../models/Etree';
import {DatePipe} from '@angular/common';
import {ClfLedgerRow} from '../models/clf-ledger';

@Injectable()
export class EtreeService {

  constructor(private httpClient: HttpClient, private datePipe: DatePipe) {
  }

  getEtrees(): Observable<HistEtree[]> {
    return this.httpClient.get<HistEtree[]>(environment.baseUrlWs + '/api/etrees');
  }

  exportEtreeJsonData(etreeId): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/export-etree-json-data?uuid=' + etreeId);
  }
  getOperationUser(companyId): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/operation-users?companyId=' + companyId);
  }

  getFileNameForExportJson(selectedEtree: Etree) {
    let xcos = '';
    // @ts-ignore
    const xcosList = selectedEtree.injectionPoint.ccps.xcos;
    const etreeID = selectedEtree.contractReference;
    // tslint:disable-next-line:forin
    for (const key in xcosList) {
      xcos = xcos + '-' + xcosList[key];
    }
    if (xcos !== '') {
      return this.formatToday() + '-' + etreeID + xcos + '.json';
    }
    return this.formatToday() + '-' + etreeID + '.json';
  }

  exportAllEtreesJsonData(): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/export-etree-json-data');
  }

  private formatToday(): string {
    const today = new Date();
    return this.datePipe.transform(today, 'yyyyMMdd');
  }

  getEtreeLedgers(historical: boolean = false): Observable<ClfLedgerRow[]> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/etrees-clf-ledger'
      + (historical ? '?historical=1' : ''));
  }
}
